<!--
  - Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
  -->

<template>
  <page>
    <template v-slot:content>
      <!--      <NotificationSection :notifications="notifications"></NotificationSection>-->
      <div class="page">
        <section class="page-section">
          <div class="page-section-content">
            <Slider></Slider>
          </div>
        </section>
        <what-where-section></what-where-section>
        <section class="page-section opening-hours">
          <div class="page-section-content">
            <div class="columns is-multiline is-centered">
              <div class="column is-narrow">
                <div class="is-flex visit-us">
                  <div class="opening-hours-heading">
                    {{ $t("Today we're") }}
                    <strong>{{ todayOpen ? $t("open") : $t("closed") }}</strong>
                  </div>
                  <div v-if="todayOpen" class="opening-hours-schedule">
                    {{ openingHours.from }} - {{ openingHours.to }}
                  </div>
                  <router-link :to="{ name: ROUTE_NAMES.VISIT_US }">
                    <button class="button is-primary is-large">
                      <span v-if="todayOpen">{{ $t("Visit us") }}</span>
                      <span v-if="!todayOpen">{{ $t("When we're open") }}</span>
                    </button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="page-section">
          <div class="page-section-content">
            <div class="two-col-grid">
              <page-tile
                :title="activeArticles.items[0].title"
                :subtitle="activeArticles.items[0].subtitle"
              >
                <template v-slot:image>
                  <img
                    :src="activeArticles.items[0].image.src"
                    class="is-hoverable-image"
                    :alt="activeArticles.items[0].image.alt"
                  />
                </template>
              </page-tile>
              <page-tile
                :has-content="true"
                :has-image="false"
                :has-media="false"
                height="100%"
              >
                <template v-slot:content>
                  <div class="articles-list">
                    <h4 class="title is-size-3">
                      <a href="/clanky&tags[]=about">
                        <span title="Show all articles about the garden"
                          >Other articles &#8594;</span
                        >
                      </a>
                    </h4>
                    <ul class="links-list">
                      <li
                        :key="`item_${idx}`"
                        v-for="(item, idx) in activeArticles.items.slice(1)"
                      >
                        <router-link :to="item.to">
                          <v-clamp autoresize :max-lines="1">{{
                            item.title
                          }}</v-clamp>
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </template>
              </page-tile>
            </div>
          </div>
        </section>
        <section class="page-section">
          <div class="section-heading">
            <div class="is-size-2 is-bold">Know more</div>
          </div>
          <div class="page-section-content">
            <div class="columns">
              <div
                :key="`card_${idx}`"
                class="column"
                v-for="(card, idx) in knowMoreCards"
              >
                <page-tile
                  :title="card.title"
                  :subtitle="card.subtitle"
                  :to="card.to"
                >
                  <template v-slot:image>
                    <img
                      :src="card.image.src"
                      class="is-hoverable-image"
                      :alt="card.image.alt"
                    />
                  </template>
                </page-tile>
              </div>
            </div>
          </div>
        </section>

        <section class="page-section">
          <div class="section-heading">
            <div class="is-size-2 is-bold">What we do</div>
          </div>
          <div class="page-section-content">
            <div class="two-col-grid">
              <page-tile
                :title="todayData.items[0].title"
                :subtitle="todayData.items[0].subtitle"
              >
                <template v-slot:image>
                  <img
                    :src="todayData.items[0].image.src"
                    class="is-hoverable-image"
                    :alt="todayData.items[0].image.alt"
                  />
                </template>
              </page-tile>
              <page-tile
                :has-content="true"
                :has-image="false"
                :has-media="false"
                height="100%"
              >
                <template v-slot:content>
                  <div class="articles-list">
                    <h4 class="title is-size-3">
                      <a href="/clanky&tags[]=about">
                        <span title="Show all articles about the garden"
                          >Might interest you &#8594;</span
                        >
                      </a>
                    </h4>
                    <ul class="links-list">
                      <li
                        :key="`item_${idx}`"
                        v-for="(item, idx) in todayData.items.slice(1)"
                      >
                        <router-link :to="item.to">
                          <v-clamp autoresize :max-lines="1">{{
                            item.title
                          }}</v-clamp>
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </template>
              </page-tile>
            </div>
          </div>
        </section>
        <br />
        <br />
      </div>
    </template>
  </page>
</template>

<script>
// import NotificationSection from "./home/notification-section";
import Slider from "./home/featured-slider";
import PageTile from "./../../components/common/page-tile";
import WhatWhereSection from "./home/what-where";
import VClamp from "vue-clamp";
import Page from "./../../components/common/page";
import { mapActions, mapGetters } from "vuex";
import { ROUTE_NAMES } from "@/routes";

export default {
  components: {
    Page,
    Slider,
    // NotificationSection,
    PageTile,
    WhatWhereSection,
    VClamp
  },
  metaInfo: {
    title: "Home"
  },
  computed: {
    ...mapGetters({
      notifications: "notifications/notifications",
      todayOpen: "openingHours/open",
      openingHours: "openingHours/hours"
    }),
    ROUTE_NAMES() {
      return ROUTE_NAMES;
    },
    knowMoreCards() {
      return [
        {
          image: {
            src: "https://static.bz-uk.roamingowl.com/images/640/7679.webp",
            alt: "Galleries"
          },
          to: { name: ROUTE_NAMES.GALLERIES },
          title: "Galleries",
          subtitle: "Categorized by exposition"
        },
        {
          image: {
            src: "https://static.bz-uk.roamingowl.com/images/640/7679.webp",
            alt: "Expositions"
          },
          to: {},
          title: "Expositions",
          subtitle: "Know more about our expositions"
        },
        {
          image: {
            src: "https://static.bz-uk.roamingowl.com/images/640/9097.webp",
            alt: "History"
          },
          to: {},
          title: "History",
          subtitle:
            "Byla založena roku 1775 v Praze na Smíchově. Kolem r. 1840 se v ní pěstovalo téměř 13 000 druhů rostlin"
        }
      ];
    },
    activeArticles() {
      return {
        count: 37,
        items: [
          {
            image: {
              src: "https://bz-uk.cz/sites/default/files/citrusy_2019_web.jpg",
              alt: "Vystva citrusu"
            },
            to: {},
            title: "Výstava citrusů a dalších užitkových rostlin",
            subtitle: "Probíhá od 27.září do 6.října 10.00-17.00"
          },
          {
            title: "Výstava andulek 2019",
            to: "/clanky/poradna"
          },
          {
            title: "Výstava Akvárium 2019",
            to: "/clanky/poradna"
          },
          {
            title: "Mezinárodní výstava halančíků",
            to: "/clanky/poradna"
          },
          {
            title: "Podzimní výstava kaktusů",
            to: "/clanky/poradna"
          },
          {
            title: "Výstava bonsají",
            to: "/clanky/poradna"
          },
          {
            title: "Výstava exotického ptactva",
            to: "/clanky/poradna"
          },
          {
            title: "Výstava výtvarných prací studentů Gymnázia Botičská",
            to: "/clanky/poradna"
          },
          {
            title: "Výstava masožravých rostlin",
            to: "/clanky/poradna"
          }
        ]
      };
    },
    todayData() {
      return {
        count: 37,
        items: [
          {
            image: {
              src: "/img/prohlidka.png",
              alt: "Tours"
            },
            to: {},
            title: "Tours",
            subtitle: "See all options of our tours and book one"
          },
          {
            title: "Poradna pro veřejnost",
            to: "/clanky/poradna"
          },
          {
            title: "Pronájem zahrady",
            to: "/clanky/pronajem"
          },
          {
            title: "Organizační řád",
            to: "/clanky/organizacni-rad"
          },
          {
            title: "Kdo jsme",
            to: "/clanky/kdo-jsme"
          },
          {
            title: "Popis zahrady",
            to: "/clanky/popis-zahrady"
          },
          {
            title: "Napsali o nás",
            to: "/clanky/napsali-o-nas"
          },
          {
            title: "Naše příspěvky v médiích",
            to: "/clanky/nase-prispevky-v-mediich"
          },
          {
            title: "Our partners",
            to: "/clanky/nasi-partneri"
          }
        ]
      };
    }
  },
  methods: {
    ...mapActions({ loadHours: "openingHours/load" })
  },
  async mounted() {
    await this.loadHours();
  }
};
</script>
<style lang="scss" scoped>
@import "page-scoped";

.links-list {
  a {
    &:hover {
      text-decoration: underline !important;
    }
  }
}

.two-col-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(345px, 1fr));
  grid-column-gap: 1.5rem;
  grid-row-gap: 1.5rem;

  @include mobile {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }
}

.visit-us {
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .opening-hours-heading {
    font-size: 2rem;
    margin: 0 0 1rem 0;
  }

  .opening-hours-schedule {
    font-size: 2rem;
    margin: 0 0 1rem 0;
  }
}
</style>
